import React, { useState, useEffect } from 'react';
import AccordionItem from './Item';

import './styles.scss';

const addFieldOpen = (data) => {
	const newDate = []

	data.forEach((el,i) => {
		const obj = {};
		for(let item in el) {
			obj[item] = el[item];
		};

		if(i === 0) {
			obj.open = true
		} else {
				
			obj.open = false
		};

		newDate.push(obj);
	});

	return newDate;
};

const Acordion = ({data = [], isAllActive}) => {
	const [items, setItems] = useState([]);

	const toggleItem = index => {   
		
		if(isAllActive) {
			setItems(items.map((item, i) => {
				if (i === index) {
					item.open = !item.open;
				};

				return item;
			}));
		} else {
			setItems(items.map((item, i) => {
				if (i === index) {
					item.open = !item.open;
				} else {
					item.open = false;
				};
		
				return item;
			}));
		};
	};

	useEffect(() =>{
		const dataWithOpen = addFieldOpen(data)
		setItems(dataWithOpen);
	},[data]);

	return (  
		<div className="accordion">
			{
				items.map((item, i) => { 
					if(items.length === 1) {
						return<AccordionItem item={item} index={i} toggleItem={toggleItem} key={i} isBorderNon/>
					} else {
						return<AccordionItem item={item} index={i} toggleItem={toggleItem} key={i}/>
					}
				})
			}
		</div>
	);
};

export default Acordion;
